// extracted by css-extract-rspack-plugin
export default {"noScroll":"_b78e8ae7","body":"_68a4677b","aboveOverlay":"_bb8ced6e","menu":"_5008abf8 _68a4677b","includePadding":"_e32a1bc6","transparent":"_d6d49ad"};